<nav class="sidebar">

  <!-- Brand header -->
  <div class="sidebar-header">
    <svg width="22" height="22" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="brand-icon">
      <defs>
        <linearGradient id="wbg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#4285f4"/>
          <stop offset="100%" stop-color="#1557c0"/>
        </linearGradient>
      </defs>
      <rect width="100" height="100" rx="22" fill="url(#wbg)"/>
      <rect x="22" y="38" width="8" height="24" rx="4" fill="white" fill-opacity="0.65"/>
      <rect x="34" y="28" width="8" height="44" rx="4" fill="white" fill-opacity="0.82"/>
      <rect x="46" y="18" width="8" height="64" rx="4" fill="white"/>
      <rect x="58" y="28" width="8" height="44" rx="4" fill="white" fill-opacity="0.82"/>
      <rect x="70" y="38" width="8" height="24" rx="4" fill="white" fill-opacity="0.65"/>
    </svg>
    @if (!collapsed()) {
      <span class="brand-name">Wave</span>
    }
  </div>

  <!-- Nav items -->
  <div class="nav-list">

    <!-- Collapse / expand toggle styled as a nav item -->
    <button class="nav-item nav-toggle" (click)="toggle()"
            [matTooltip]="collapsed() ? 'Expand' : ''" matTooltipPosition="right"
            aria-label="Toggle navigation">
      <mat-icon class="nav-icon">{{ collapsed() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
      @if (!collapsed()) { <span class="nav-label">Collapse</span> }
    </button>

    <app-notification-bell [collapsed]="collapsed()" />

    <ng-container *hasPermission="'accounts.view_all'">
      <a routerLink="/accounts" routerLinkActive="active" class="nav-item"
         [matTooltip]="collapsed() ? 'Accounts' : ''" matTooltipPosition="right">
        <mat-icon class="nav-icon">corporate_fare</mat-icon>
        @if (!collapsed()) { <span class="nav-label">Accounts</span> }
      </a>
    </ng-container>

    @if (!auth.isAdmin && auth.currentUser()?.account_id) {
      <a [routerLink]="['/accounts', auth.currentUser()!.account_id]"
         routerLinkActive="active" class="nav-item"
         [matTooltip]="collapsed() ? 'Dashboard' : ''" matTooltipPosition="right">
        <mat-icon class="nav-icon">dashboard</mat-icon>
        @if (!collapsed()) { <span class="nav-label">Dashboard</span> }
      </a>
    }

    <a routerLink="/projects" routerLinkActive="active" class="nav-item"
       [matTooltip]="collapsed() ? 'Projects' : ''" matTooltipPosition="right">
      <mat-icon class="nav-icon">folder_open</mat-icon>
      @if (!collapsed()) { <span class="nav-label">Projects</span> }
    </a>

    <a routerLink="/action-items" routerLinkActive="active" class="nav-item"
       [matTooltip]="collapsed() ? 'Action Items' : ''" matTooltipPosition="right">
      <mat-icon class="nav-icon">task_alt</mat-icon>
      @if (!collapsed()) { <span class="nav-label">Action Items</span> }
    </a>

    <a routerLink="/tickets" routerLinkActive="active" class="nav-item"
       [matTooltip]="collapsed() ? 'Tech Requests' : ''" matTooltipPosition="right">
      <mat-icon class="nav-icon">build_circle</mat-icon>
      @if (!collapsed()) { <span class="nav-label">Tech Requests</span> }
    </a>

    <a routerLink="/workspace" routerLinkActive="active" class="nav-item"
       [matTooltip]="collapsed() ? 'My Workspace' : ''" matTooltipPosition="right">
      <mat-icon class="nav-icon">work_outline</mat-icon>
      @if (!collapsed()) { <span class="nav-label">My Workspace</span> }
    </a>

    <div class="nav-divider"></div>

    <button class="nav-item nav-ask-wave" (click)="chatOpen.requestOpen()"
            [matTooltip]="collapsed() ? 'Ask Wave' : ''" matTooltipPosition="right"
            aria-label="Open Ask Wave">
      <mat-icon class="nav-icon">auto_awesome</mat-icon>
      @if (!collapsed()) { <span class="nav-label">Ask Wave</span> }
    </button>

    <button class="nav-item nav-feedback" (click)="openFeedback()"
            [matTooltip]="collapsed() ? 'Share Feedback' : ''" matTooltipPosition="right"
            aria-label="Share Feedback">
      <mat-icon class="nav-icon">rate_review</mat-icon>
      @if (!collapsed()) { <span class="nav-label">Feedback</span> }
    </button>

    <ng-container *hasPermission="'accounts.view_all'">
      <div class="nav-divider"></div>
      <a routerLink="/admin-settings" routerLinkActive="active" class="nav-item"
         [matTooltip]="collapsed() ? 'Admin Settings' : ''" matTooltipPosition="right">
        <mat-icon class="nav-icon">admin_panel_settings</mat-icon>
        @if (!collapsed()) { <span class="nav-label">Admin Settings</span> }
      </a>
    </ng-container>

  </div>

  <!-- User footer -->
  <button class="sidebar-footer" [matMenuTriggerFor]="userMenu"
          [matTooltip]="collapsed() ? (auth.currentUser()?.name ?? '') : ''" matTooltipPosition="right"
          aria-label="Account menu">
    @if (auth.currentUser()?.profile_picture) {
      <img class="user-avatar user-avatar--img"
           [src]="auth.currentUser()!.profile_picture!"
           alt="Profile"
           referrerpolicy="no-referrer" />
    } @else {
      <span class="user-avatar">{{ initial }}</span>
    }
    @if (!collapsed()) {
      <div class="user-info">
        <span class="user-name">{{ auth.currentUser()?.name }}</span>
        @if (persona()) {
          <span class="user-meta">{{ persona() }}</span>
        }
        @if (gamification()) {
          <div class="user-gamification">
            <span class="user-level-chip">Lv.{{ gamification()!.level }}</span>
            @if (gamification()!.login_streak > 0) {
              <span class="user-streak-chip">🔥 {{ gamification()!.login_streak }}</span>
            }
          </div>
        }
      </div>
      <mat-icon class="footer-more">more_vert</mat-icon>
    }
  </button>

  <mat-menu #userMenu="matMenu" xPosition="after" yPosition="above" panelClass="user-action-menu">
    <div class="user-menu-header">
      @if (auth.currentUser()?.profile_picture) {
        <img class="user-avatar user-avatar--img user-avatar--lg"
             [src]="auth.currentUser()!.profile_picture!"
             alt="Profile"
             referrerpolicy="no-referrer" />
      } @else {
        <span class="user-avatar user-avatar--lg">{{ initial }}</span>
      }
      <div>
        <div class="menu-user-name">{{ auth.currentUser()?.name }}</div>
        <div class="menu-user-email">{{ auth.currentUser()?.email }}</div>
      </div>
    </div>
    <mat-divider />
    <button mat-menu-item [routerLink]="['/profile']">
      <mat-icon>manage_accounts</mat-icon>
      My Profile
    </button>
    <button mat-menu-item (click)="theme.toggle()">
      <mat-icon>{{ theme.mode() === 'dark' ? 'light_mode' : 'dark_mode' }}</mat-icon>
      {{ theme.mode() === 'dark' ? 'Light Mode' : 'Dark Mode' }}
    </button>
    <button mat-menu-item (click)="auth.logout()">
      <mat-icon>logout</mat-icon>
      Sign out
    </button>
  </mat-menu>

</nav>
